<template>
  <div id="water-level-chart">
    <!-- <div class="water-level-chart-title">累计通话时长</div> -->
   <div class="water-level-chart-title">满意度</div>
    <div class="water-level-chart-details">
      <!-- <span>{{tCallLen}} </span>秒 -->
    </div>

    <div class="chart-container" style="margin-top:-70px;">
      <!-- <dv-water-level-pond :config="config" /> -->
      <!-- <dv-decoration-9 style="width:150px;height:150px;">满意度：{{investRate}}%</dv-decoration-9> -->
      <dv-decoration-9 style="width:150px;height:150px;">{{investRate}}%</dv-decoration-9>
      <!-- <span>满意度</span> -->
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'WaterLevelChart',
  computed: {...mapGetters(['titleList'])},
  data () {
    return {
      config: {
        data: [],
        shape: 'round',
        waveHeight: 25,
        waveNum: 2
      },
      tCallLen:0,
      investRate:0,
    }
  },

  mounted () {
    const { createData } = this

    createData()

    // setInterval(createData, 3000)
  },

  methods: {
    async createData () {
      await this.$store.dispatch('screen/screenSet',{}).then(Response=>{
        this.tCallLen = this.titleList[0].tCallLen;
        this.investRate = this.titleList[0].InvestRate;
        // this.config.data = [this.titleList[0].InvestRate];        
        // this.config = { ...this.config }

      })

      // if (this.titleList.length>0){
      //   const { config } = this;
      //   this.config.data = this.titleList[0].tCallLen;
      //   this.config = { ...this.config }

      //   this.loaded=true;
      //   clearInterval(intervalEvent);  
      // }

    }
  },

}
</script>

<style lang="less">
#water-level-chart {
  width: 20%;
  box-sizing: border-box;
  margin-left: 20px;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, .5);
  display: flex;
  flex-direction: column;

  .water-level-chart-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
    justify-content: center;
  }

  .water-level-chart-details {
    height: 15%;
    display: flex;
    justify-content: center;
    font-size: 17px;
    align-items: flex-end;

    span {
      font-size: 35px;
      font-weight: bold;
      color: #58a1ff;
      margin: 0 5px;
      margin-bottom: -5px;
    }
  }

  .chart-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dv-water-pond-level {
    max-width: 90%;
    width: 200px;
    height: 200px;
    border: 10px solid #19c3eb;
    border-radius: 50%;

    ellipse {
      stroke: transparent !important;
    }

    text {
      font-size: 40px;
    }
  }
}
</style>
